import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import store from './store/index'
import VueRouter from 'vue-router'
import MyProfile from './components/MyProfile'
import CapLogs from './components/CapLogs'
import * as firebaseConfig from './firebase/index'
import Vuex from 'vuex'

firebaseConfig.initializeMyApp();

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.config.productionTip = false


// 1. Define route components.
// These can be imported from other files
const Foo = { template: '<div>foo</div>' }
const Bar = { template: '<div>bar</div>' }

// 2. Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
  { path: '/', component: CapLogs },
  { path: '/bar', component: Bar },
  { path: '/contact', component : MyProfile},
  { path: '/caplogs', component : CapLogs}

]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes // short for `routes: routes`
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
